import React, { ComponentProps } from 'react'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import LuxuryPlusLabel from './LuxuryPlusLabel'
import Group from 'components/utils/Group'

interface Props extends ComponentProps<typeof PriceRowPrice> {
  memberPrice: number;
}

function LuxuryPlusPriceStickyHeader(props: Props) {
  const { memberPrice, saleUnit, taxesAndFees, size, 'data-testid': TestId } = props

  return <Group direction="horizontal" desktopDirection="horizontal-reverse" gap={4} horizontalAlign="start">
    <PriceRowPrice
      size={size}
      price={memberPrice}
      saleUnit={saleUnit}
      data-testid={TestId}
      taxesAndFees={taxesAndFees}
    />
    <LuxuryPlusLabel type="only-logo" size="small" />
  </Group>
}

export default LuxuryPlusPriceStickyHeader
